$(document).ready(function() {
	if(!document.querySelector('.GPC0066')) return false;

	var target = $('.GPC0066');
	//LGEGMC-1633 START
	var tableCollapse = function(){
		var btn = target.find('.btn-collapse a');
		btn.on('click',function(e){
			e.preventDefault();
			var tableObj = $(this).parent().next('.information-table, .tbl-wrap');
			var tableBtm = tableObj.find('.table-bottom');

			if ($(this).parent().hasClass('btn-close'))
			{
				$(this).parent().removeClass('btn-close').addClass('open');
				$(this).attr('aria-expanded', false);
				$(this).addClass('active');
				$(this).text($(this).attr('data-open-text'));
				var collapseHeight = parseInt(tableObj.find('thead').outerHeight(true) + 2); // LGEDE-542
				tableObj.stop().animate({height:collapseHeight},400,"easeOutQuad",function(){
					tableBtm.hide();
					tableObj.css({
						//height:'auto'
						height:collapseHeight
					});
				});
				if(tableObj.hasClass("tbl-wrap")){
					tableObj.find(".information-table").addClass('tableBtm-hidden');
				}else{
					tableObj.addClass('tableBtm-hidden');
				}
				
			} else {
				$(this).parent().removeClass('open').addClass('btn-close');
				$(this).removeClass('active');
				$(this).attr('aria-expanded', true);
				$(this).text($(this).attr('data-close-text'));
				tableObj.css({
					height:tableObj.outerHeight(true)
				});
				tableBtm.show();
				var collapseHeight = parseInt(tableObj.find('thead').outerHeight(true) + tableBtm.outerHeight(true) + 1); // LGEDE-542
				tableObj.stop().animate({height:collapseHeight},400,"easeOutQuad",function(){
					tableObj.css({
						//height:'auto'
						height:collapseHeight
					});
				});
				if(tableObj.hasClass("tbl-wrap")){
					tableObj.find(".information-table").removeClass('tableBtm-hidden');
				}else{
					tableObj.removeClass('tableBtm-hidden');
				}
			}
		});
	};
	
	// LGEDE-542 Start
	var lazyLoadHeight = function(){
		var isMobile = $('.visible-m').is(':visible'); 
		console.log(isMobile);
		var	visibleClass = isMobile ? '.visible-m' : '.visible-w',
			tableClass = isMobile ? '.information-table.floating-table' : '.information-table',
			summaryClass = isMobile ? '.tbl-wrap' : tableClass,
			$visible, $table, summaryHeight;

			$visible = target.find(visibleClass);
			$table = $visible.find(tableClass);
			summaryHeight = $table.find('thead').outerHeight(true);
			$visible.find(summaryClass).css('height',summaryHeight);
	}
	// LGEDE-542 End

	//LGEDE-399, LGEDE-493 START
	/* 메시지코드를 이용하여 해당 URL이면 테이블 뷰를 닫힘으로 변경(collapse 클릭이벤트 실행) */
	var checkedUrl = function(){
		var currentUrl = window.location.href;
		var checkedUrlList = target.find('#noExtendCheckUrl').val();
		var btn = target.find('.btn-collapse a');
		
		var checkedUrl = checkedUrlList.split(',');
		
		for(var i=0; i<checkedUrl.length; i++){
			if($.trim(checkedUrl[i]) != '' && currentUrl.indexOf($.trim(checkedUrl[i])) > -1){
				btn.trigger("click");

				// LGEDE-542 Start
				$(".information-table table .image-block img").on({
					load : function(){
						lazyLoadHeight();
					}
				});
				// LGEDE-542 End

				break;
			}
		}
	};
	// LGEDE-399, LGEDE-493 END



	var tableScrollWidth = function(){
		var targetMTble = target.find('.visible-m');

		if(targetMTble.css("display") == "block"){
			var targetBox = targetMTble.find(".floating-table");
			targetBox.each(function(){
				var targetTdLength = $(this).find(".table-wrap thead tr:first-child th").length;
				var targetTdWidth = 160;//고정값

				$(this).find(".position-wrap").width(targetTdLength*targetTdWidth);

				//2개일때 윈도우사이즈에 맞추기
				if(targetTdLength == 2){
					var width_size = window.outerWidth;
					var sumTdWidth = targetTdLength * targetTdWidth;
					if(sumTdWidth < (width_size - 140)){
						targetTdWidth = (width_size - 140) / targetTdLength;
						$(this).find(".position-wrap").width(targetTdLength*targetTdWidth);
					}
				}
			});
		}
	};
	
	tableCollapse();
	checkedUrl(); //LGEDE-399
	tableScrollWidth();

	var mobileTableHeightSetting = function(){
		var $targetTbl = target.find(".floating-table");
		var $targetTblTr = $targetTbl.find("tr");
		var $thTbl = target.find(".th-table");
		var $thTblTr = $thTbl.find("tr");

		var targetArr1 = [];
		var thArr2 = [];
		var arr = [];

		$targetTblTr.each(function(idx){
			var height = $(this).find("td, th").outerHeight(true);
			targetArr1.push(height);
		});
		$thTblTr.each(function(idx){
			var height = $(this).find("th").outerHeight(true);
			thArr2.push(height);
		});

		targetArr1.forEach(function(item, idx){
			thArr2.forEach(function(item2, idx2){
				if(idx == idx2){
					if(item >= item2){
						arr.push(item);
					}else{
						arr.push(item2);
					}
				}
			});
		});

		$targetTblTr.each(function(idx){
			var pdt = $(this).find("td, th").css("padding-top");
			var pdb = $(this).find("td, th").css("padding-bottom");
			var bdrt = $(this).find("td, th").css("border-top-width");
			var bdrb = $(this).find("td, th").css("border-bottom-width");
			var gap1 = 0;
			if(parseInt(bdrt) >= 2){
				gap1 = parseInt(bdrt);
			}
			var gap2 = 0;
			if(parseInt(bdrb) >= 1){
				gap2 = parseInt(bdrb);
			}
			$(this).find("td, th").height(arr[idx] - parseInt(pdt) - parseInt(pdb) - gap1 - gap2);
		});
		$thTblTr.each(function(idx){
			var pdt = $(this).find("th").css("padding-top");
			var pdb = $(this).find("th").css("padding-bottom");
			var bdrt = $targetTblTr.eq(idx).find("td, th").css("border-top-width");
			var bdrb = $targetTblTr.eq(idx).find("td, th").css("border-bottom-width");

			var gap2 = 0;
			if(parseInt(bdrb) >= 1){
				gap2 = parseInt(bdrb);
			}

			$(this).find("th").height(arr[idx] - parseInt(pdt) - parseInt(pdb) - gap2);
			if($(this).hasClass("cta-button")){
				$(this).find("th").height(arr[idx] - parseInt(pdt) - parseInt(pdb) -1);
			}
		});
	}

	//테이블 내 이미지 로드 후 th 높이값 계산
	/*
	$(window).on({
		load : function(){
			mobileTableHeightSetting();
		},
		resize : function(){
			var width_size = window.outerWidth;
			if(width_size <= 767){
				tableScrollWidth();
				console.log("resize");
				setTimeout(function(){
					mobileTableHeightSetting();
				}, 500);
			}
		}
	});
	*/
	//테이블 내 이미지 로드 후 th 높이값 계산
	$(".floating-table img").on({
		load : function(){
			mobileTableHeightSetting();
		}
	});
	/* LGCOMSPEED-6 Start */
	if($(".floating-table img").hasClass('lazyloaded')){
		mobileTableHeightSetting();
	}
	/* LGCOMSPEED-6 End */
	$(window).on({
		resize : function(){
			var width_size = window.outerWidth;
			if(width_size <= 767){
				tableScrollWidth();
				mobileTableHeightSetting();
			}
		}
	});
	//LGEGMC-1633 END

	/* LGEGMC-1633 : 20210702 add */ 
	target.find('.item-title').each(function (idx, item) {
		if ($.trim($(item).text()) == $.trim($('.GPC0009 .pdp-info.desktop-info .model-name').text()) && !!$('.GPC0009').length)
		{
			$(this).parents('.GPC0066').find ('.item' + idx).addClass('active-model');
			$(this).prepend('<span class="check">' + $(this).data('check-model') + '</span>')
		}
	}); 
	/*// LGEGMC-1633 : 20210702 add */
});